// 可指定拖拽位置
const dragConfig = ['top', 'left', 'bottom', 'right']
export default {
  bind(boxEl, { value, modifiers }) {
    // 是否只在内部移动
    const isInside = modifiers['inside']
    // 拖拽位置
    const drag = dragConfig.find(v => modifiers[v])
    if (!(value && !drag)) {
      boxEl.addEventListener('mousedown', onmousedown, false)
    }
    boxEl.addEventListener('mousemove', onmousemove, false)
    // 鼠标移动，用于判断是否未可移动区域
    function onmousemove(e) {
      // 通过css选择器指定拖拽的元素
      if (value && !drag) {
        const dragEl = document.querySelector(value)
        if (dragEl) {
          dragEl.style.cursor = 'move'
          dragEl.onmousedown = onmousedown
          boxEl.removeEventListener('mousemove', onmousemove, false)
        }
        return
      }
      const position = Object.assign({ mouseX: e.clientX, mouseY: e.clientY, height: boxEl.offsetHeight, width: boxEl.offsetWidth, offsetLeft: boxEl.offsetLeft, offsetTop: boxEl.offsetTop }, getPosition(boxEl))
      const canMove = checkMove(drag, value, position)
      if (canMove) {
        boxEl.style.cursor = 'move'
        // 将值设置在dragCursor上，resizer指令如果有配置会在这里获取鼠标状态
        boxEl.setAttribute('dragCursor', 'move')
      } else {
        boxEl.style.cursor = ''
        boxEl.setAttribute('dragCursor', '')
      }
    }
    // 按下鼠标瞬间
    function onmousedown(e) {
      // 父容器
      const boxParentEl = boxEl.offsetParent || document.documentElement
      const position = Object.assign({ mouseX: e.clientX, mouseY: e.clientY, height: boxEl.offsetHeight, width: boxEl.offsetWidth, offsetLeft: boxEl.offsetLeft, offsetTop: boxEl.offsetTop }, getPosition(boxEl))
      const disX = e.clientX // 记录鼠标点下X轴位置
      const disY = e.clientY // 记录鼠标点下的Y轴位置
      const canMove = checkMove(drag, value, position)
      if (canMove) {
        document.body.style.userSelect = 'none'
        document.addEventListener('mousemove', docMove, false)
        document.addEventListener('mouseup', onmouseup, false)
      }
      function docMove(e) {
        const moveX = e.clientX - disX // 鼠标移动的x轴距离
        const moveY = e.clientY - disY // 鼠标移动的Y轴距离
        const x = moveX + position.offsetLeft // 与原本位置相加，算出目前X轴位置
        const y = moveY + position.offsetTop // 与原本位置相加，算出目前Y轴位置
        // 判断是否只允许在内部移动
        const left = isInside ? Math.min(Math.max(0, x), boxParentEl.clientWidth - boxEl.offsetWidth) : x
        const top = isInside ? Math.min(Math.max(0, y), boxParentEl.clientHeight - boxEl.offsetHeight) : y
        boxEl.style.left = `${left}px`
        boxEl.style.top = `${top}px`
      }
      function onmouseup() {
        document.body.style.userSelect = ''
        document.removeEventListener('mousemove', docMove, false)
        document.removeEventListener('mouseup', onmouseup, false)
      }
    }
    // 获取盒子相对于body的坐标
    function getPosition(e) {
      if (e) {
        const offsetLeft = e.offsetLeft
        const offsetTop = e.offsetTop
        const parentPosition = getPosition(e.offsetParent)
        return {
          x: offsetLeft + parentPosition.x,
          y: offsetTop + parentPosition.y
        }
      }
      return { x: 0, y: 0 }
    }
    // 使用鼠标位置判断是否处于允许拖拽的范围
    function checkMove(drag, value, position) {
      // 不要处于拉伸区域
      const isResizer = boxEl.getAttribute('isResizer')
      const canDrag = !isResizer || isResizer === 'false'
      const { mouseX, mouseY, x, y, width, height } = position
      if (drag === 'top') {
        return mouseY - y <= value && mouseY > y && canDrag
      } else if (drag === 'left') {
        return mouseX - x <= value && mouseX > x && canDrag
      } else if (drag === 'bottom') {
        const bottom = height - (mouseY - y)
        return bottom <= value && mouseY > y && bottom > 0 && canDrag
      } else if (drag === 'right') {
        const right = width - (mouseX - x)
        return right <= value && mouseX > x && right > 0 && canDrag
      } else {
        return true && canDrag
      }
    }
  }
}
